import { useQuery } from '@tanstack/react-query'

import { toast } from '@/components/ui'
import { projectService } from '@/services/http/projectService'

type UseGetPortfolioProjectTagsParams = {
  projectId: string
  enabled?: boolean
}

export function useGetPortfolioProjectTags({
  projectId,
  enabled = true,
}: UseGetPortfolioProjectTagsParams) {
  const { data, isLoading, refetch, isError } = useQuery({
    queryKey: ['portfolioProjectTags', projectId],
    queryFn: () =>
      projectService.portfolio.getPortfolioProjectTags({ projectId }),
    enabled,
  })

  if (isError) {
    toast({
      title: 'Erro ao buscar tags do projeto',
      variant: 'destructive',
    })
  }

  if (data) {
    return {
      tags: data,
      isLoading,
      isError,
      refetchTags: refetch,
    }
  }

  return {
    tags: [],
    isLoading,
    isError,
    refetchTags: refetch,
  }
}
